/* global APP */

import React from 'react';
import ReactDOM from 'react-dom';

import { App } from './features/app/components';
import { getLogger } from './features/base/logging/functions';
import { kickParticipant, PARTICIPANT_ROLE } from './features/base/participants';
import { Platform } from './features/base/react';
import { getJitsiMeetGlobalNS } from './features/base/util';
import PrejoinApp from './features/prejoin/components/web/PrejoinApp';

const logger = getLogger('index.web');
const OS = Platform.OS;

/**
 * Renders the app when the DOM tree has been loaded.
 */
document.addEventListener('DOMContentLoaded', () => {
    const now = window.performance.now();

    APP.connectionTimes['document.ready'] = now;
    logger.log('(TIME) document ready:\t', now);
});

// Workaround for the issue when returning to a page with the back button and
// the page is loaded from the 'back-forward' cache on iOS which causes nothing
// to be rendered.
if (OS === 'ios') {
    window.addEventListener('pageshow', event => {
        // Detect pages loaded from the 'back-forward' cache
        // (https://webkit.org/blog/516/webkit-page-cache-ii-the-unload-event/)
        if (event.persisted) {
            // Maybe there is a more graceful approach but in the moment of
            // writing nothing else resolves the issue. I tried to execute our
            // DOMContentLoaded handler but it seems that the 'onpageshow' event
            // is triggered only when 'window.location.reload()' code exists.
            window.location.reload();
        }
    });
}

window.addEventListener('beforeunload', () => {

    const state = APP.store.getState();

    const participants = state['features/base/participants'];
    const conference = state['features/base/conference'];
    const codecParticipant = Object.keys(participants).filter(con => con.isJigasi);

    const localParticipant = Object.keys(participants)?.find(item => item.local);

    if (conference.room && localParticipant && localParticipant.role === PARTICIPANT_ROLE.MODERATOR) {
        participants.forEach(p => {
            if (!p.local && p.id) {
                APP.store.dispatch(kickParticipant(p.id));
            }
        });
        APP.store.dispatch(kickParticipant(codecParticipant[0].id));
    }
});

const globalNS = getJitsiMeetGlobalNS();

globalNS.entryPoints = {
    APP: App,
    PREJOIN: PrejoinApp
};

globalNS.renderEntryPoint = ({
    Component,
    props = {},
    elementId = 'react'
}) => {
    ReactDOM.render(
        <Component { ...props } />,
        document.getElementById(elementId)
    );
};
